<template>
	<div
		class="flow-m-pack-group-container"
		:selected="selected"
		:tabindex="tabindex"
		@click="handleClick($event)"
	>
		<div class="flow-m-pack-group-header">
			<slot name="header" />
		</div>
		<div class="flow-m-pack-group-content">
			<div class="flow-m-pack-group-content-slot">
				<slot />
			</div>
			<div class="flow-m-pack-group-content-icon">
				<Icon
					name="chevron"
					size="small"
					:rotate="expandContent ? 180 : 0"
					@click="toggleContent($event)"
				/>
			</div>
		</div>
		<div class="flow-m-pack-group-content-expanded">
			<p
				v-if="!expandContent"
				class="paragraph-1 fc-light display-flex align-items-center margin-tp-8 upper-case"
			>
				{{ footerLabel }}
			</p>
			<div v-if="expandContent" class="margin-tp-16">
				<slot name="content" />
			</div>
		</div>
		<div v-if="$slots['footer']" class="flow-m-pack-group-footer">
			<slot name="footer" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "MediaPackagingGroup",
	components: {
		Icon
	},
	props: {
		footerLabel: {
			type: String,
			default: null
		},
		expandContent: {
			type: Boolean,
			default: false
		},
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},
		selected: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		toggleContent(e) {
			//	console.log("toggleFooter");
			this.$emit("toggleContent", e);
		},
		handleClick(e) {
			e.stopPropagation();
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
div.flow-m-pack-group-container {
	display: flex;
	flex-direction: column;
	border-radius: 12px;
	border: 1px solid var(--slideout-border);
	background-color: var(--slideout-element-light);
	> div.flow-m-pack-group-header {
		display: flex;
		align-items: center;
		height: 60px;
		border-bottom: 1px solid var(--slideout-border);
		padding: 16px;

		> * + * {
			margin-left: 8px;
		}
		> * + h4 {
			margin-left: 16px;
		}
		> * + [name="pencil"] {
			margin-left: auto;
		}
	}

	> div.flow-m-pack-group-content {
		display: flex;
		justify-content: space-between;
		> div.flow-m-pack-group-content-slot {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
		}

		> div.flow-m-pack-group-content-icon {
			display: flex;
			align-items: flex-end;
		}
		// min-height: 110px;
		padding: 16px 16px 0px 16px;
	}

	> div.flow-m-pack-group-content-expanded {
		margin-left: 28px;
		padding: 0px 16px 16px 16px;
	}

	> div.flow-m-pack-group-footer {
		padding: 16px;
		border-top: 1px solid var(--slideout-border);
	}

	&:active {
		filter: contrast(90%);
	}

	&:hover:not(:active) {
		filter: contrast(95%);
	}
	&:focus {
		box-shadow: inset 0 0 0 1px var(--slideout-primary);
		outline: none;

		> div.flow-m-pack-group-header {
			border-bottom: 1px solid var(--slideout-primary);
		}

		> div.flow-m-pack-group-footer {
			border-top: 1px solid var(--slideout-primary);
		}
	}

	&[selected] {
		box-shadow: inset 0 0 0 1px var(--slideout-success);
		outline: none;

		> div.flow-m-pack-group-header {
			border-bottom: 1px solid var(--slideout-success);
		}

		> div.flow-m-pack-group-footer {
			border-top: 1px solid var(--slideout-success);
		}
	}
}
</style>
